import moment from 'moment';
import 'moment/locale/fr';

import { getLocale } from './store/state/util';

moment.locale(getLocale());
